export enum OAuthScope {
    FAMILY = 'family',
    E_PUBLISHING = 'e-publishing',
    EBOOK_LIBRARY = 'ebook_library',
}
